const DEPRECATED_EVENT_LABELS = Object.freeze(Object.assign(Object.create(null), {
  NEW_HOME_COIN_ONE_PERCENT: "โอนกรรมสิทธิ์ 1%",
  CUSTOMER_CREATE_WALLET: "เปิดกระเป๋า wallet",
  BUY_RJ_PACKAGE_ONE_PERCENT: "ซื้อของ RJ 1%",
  BUY_RJ_PACKAGE_TWO_PERCENT: "ซื้อของ RJ 2%"
}));

export const getDeprecatedEventLabel = (eventCode) => DEPRECATED_EVENT_LABELS[eventCode] ?? '-';
